export default "__VITE_ASSET__BjiHGCf0__"